import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Row, Col, Accordion } from 'react-bootstrap';
import './release-notes.component.css';
import { releaseNotesActions } from '../../../store/external/release-notes-reducer/release-notes-reducer';
import { convertToDate } from '../../../utils/helpers.utils';
import { RequestHeaders } from '../../common/header-logo/request-header.component';
import { NoSubscription } from '../dashboard/no-subscription/no-subscription.component';


class ReleaseNotes extends Component {
    componentDidMount() {
        var state = this.props;
        state.fetchReleaseNotesItems();
    }
    renderbyReleaseToggle = (releaseNotes) => {
        return Object.values(releaseNotes).map((item, index) => {
            var releaseName = "ATEM version build " + item.ReleaseName;
            return (
                <Accordion key={index} defaultActiveKey={[0]}>
                    <Accordion.Item eventKey={index}>
                        <Accordion.Header>{releaseName}</Accordion.Header>
                        <Accordion.Body>
                            {this.renderByReleaseName(item)}
                        </Accordion.Body>
                        {/* <Collapsible trigger={releaseName} open={index === 0}>*/}
                        {/*  </Collapsible>*/}
                    </Accordion.Item>
                </Accordion>
            );
        });
    }
    renderByReleaseName = (item) => {
        return (
            <div>
                <Row key={item.ReleaseId}>
                    <Col xs={12} md={12} >
                        <p className="release-notes-desc">What's new in ATEM version build {item.ReleaseName}?</p>
                    </Col>
                    <Col xs={12} md={12} >
                        <p className="release-notes-desc">{convertToDate(item?.ReleaseDate, 'DD MMM YYYY')}</p>
                    </Col>
                    <Col xs={12} md={12} >
                        <p className="release-notes-desc-detail">What's new?</p>
                        <ul>
                            <li className="release-notes-desc-detail-li"> {item.ReleaseDescription} </li>
                        </ul>
                    </Col>
                    <Col xs={12} md={12} >
                        <p className="release-notes-desc-detail">This version build includes bug fixes and improvements. This update:</p>
                        {this.renderReleaseDetails(item.ReleaseItems)}
                    </Col>
                </Row>
            </div>
        );
    }

    renderReleaseDetails = (details) => {
        const noteItems = details.map((note, index) =>
            <li key={index} className="release-notes-desc-detail-li"> {note} </li>
        );
        return (
            <Row className="release-notes-details">
                <ul>{noteItems}</ul>
            </Row>
        );
    }

    render() {
        const { releaseNotes } = this.props;
        return (
            <div> 
                <RequestHeaders headerTitle="release_note" />
                <div className="request-table data-table fit-width">
                <Row>
                    <Col xs={12} md={12} lg={12}>
                        {releaseNotes?.isFetching ? 
                        <NoSubscription customClass="loading-page" title="Loading, Please Wait…" />
                            : <div className="release-notes-body">
                                {this.renderbyReleaseToggle(releaseNotes?.releaseNotes)}
                            </div>
                        }
                    </Col>
                </Row>
                </div>

            </div>
        );
    }

}


export default connect(
    state => { return { releaseNotes: state.releaseNotes }; },
    dispatch => bindActionCreators(releaseNotesActions, dispatch)
)(ReleaseNotes);
